<template>
  <div class="container">
    <form class="form-inline">
      <div class="form-group">
        <label class="sr-only" for="exampleInputEmail3">团号</label>
        <input type="text" class="form-control" v-model="form.tripAlias" id="exampleInputEmail3" placeholder="团号">
      </div>
      <div class="form-group">
        <label class="sr-only" for="exampleInputPassword3">开始日期</label>
        <input class="form-control" data-field="date" v-model="form.start" id="exampleInputPassword3" placeholder="开始日期">
      </div>
      <div class="form-group">
        <label class="sr-only" for="exampleInputPassword3">结束日期</label>
        <input class="form-control" data-field="date" v-model="form.end" id="exampleInputPassword3" placeholder="结束日期">
      </div>
      <button type="button" @click="go(form)" class="btn btn-success">搜索</button>
    </form>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>旅行名称</th>
          <th>团号</th>
          <th>模板名称</th>
          <th>姓名</th>
          <th>手机号</th>
          <th>领队</th>
        </tr>
      </thead>
      <tbody v-for="item in data.data">
        <tr @click="showAns(item)">
          <td>{{item.abbreviation}}({{item.start}})</td>
          <td>{{item.alias}}</td>
          <td>{{item.name}}</td>
          <td>{{item.userName}}</td>
          <td>{{item.mobile}}</td>
          <td>
            <span v-if="item.leader">
            {{item.leader.name}}({{item.leader.mobile}})
            </span>
          </td>
        </tr>
        <tr v-if="item.isShowAns">
          <td colspan="6">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th>问题</th>
                  <th>答案</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ans in item.answer" track-by="$index">
                  <td>{{$index + 1}}</td>
                  <td>
                    {{ans.question}}
                  </td>
                  <td>
                    <div>{{ans.answer}}</div>
                  </td>
                </tr>
               </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <nav class="text-center">
      <ul class="pagination">
        <li v-for="item in data.last_page" track-by="$index" :class="{active: data.current_page == $index + 1}">
          <a href="javascript:void(0)" @click="go({
            page: $index + 1
          })">{{$index + 1}}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import config from '../../libs/config'

  export default {
    data () {
      return {
        data: {},
        form: {
          tripAlias: '',
          start: '',
          end: ''
        }
      }
    },
    methods: {
      fetchList () {
        let params = Object.assign({ page: 1 }, this.$route.query)
        return this.$http.get(`${config.apiWe}/product/feedback`, params)
          .then(({data}) => {
            data.data.forEach((item) => {
              item.isShowAns = false
            })
            this.data = data
          })
      },
      go (query) {
        this.$router.go({ query: Object.assign({}, this.$route.query, query) })
      },
      showAns (item) {
        item.isShowAns = !item.isShowAns
      }
    },
    route: {
      data () {
        return this.fetchList()
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** MemberList.vue?77599ea4
 **/